// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1syWZ","header":"ClearentDisclaimer_header__3er8I","inner":"ClearentDisclaimer_inner__3allg"};